import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    mutation ($userId: Int!, $promotionCode: String) {\n        setUserSignupComplete(userId: $userId, promotionCode: $promotionCode) {\n            ok\n            errors {\n                path\n                message\n            }\n        }\n    }  \n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import gql from 'graphql-tag';
import { Header, Divider, Message, Segment } from 'semantic-ui-react';
import ConfirmDetailsForm from '@emyw/pay-lib/ConfirmDetailsForm';
import { AccountClient, log, getLocalStorageWithExpiry, setLocalStorageWithExpiry } from '@emyw/core-lib';
import { getPlanCostLabel, DEFAULT_PROMO_CODE } from '../utils'; // import { ButtonLink } from '@emyw/auth-lib';

var FREE = process.env.REACT_APP_FREE_PLAN_CODE;
var setUserSignupCompleteMutation = gql(_templateObject());

var Step4ConfirmDetails = /*#__PURE__*/function (_React$Component) {
  _inherits(Step4ConfirmDetails, _React$Component);

  var _super = _createSuper(Step4ConfirmDetails);

  function Step4ConfirmDetails() {
    var _this;

    _classCallCheck(this, Step4ConfirmDetails);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      processing: false,
      errors: []
    };

    _this.handleComplete = function (user, onComplete) {
      _this.setState({
        processing: true
      });

      var context = _this.props.context;
      var ReactGA = context && context.state && context.state.ReactGA;
      AccountClient.mutate({
        mutation: setUserSignupCompleteMutation,
        variables: {
          userId: user.userId,
          promotionCode: getLocalStorageWithExpiry('enjoy-promo-code')
        }
      }).then(function (response) {
        log.trace('response:', response);
        var _response$data$setUse = response.data.setUserSignupComplete,
            ok = _response$data$setUse.ok,
            errors = _response$data$setUse.errors;

        if (ok) {
          // Check for google analytics
          log.trace('check for analytics', ReactGA);
          var partner = getLocalStorageWithExpiry('partner-origin');
          var subscriptionLevelCode = user.subscriptionLevelCode,
              subscriptionLevelMonthlyCostFormatted = user.subscriptionLevelMonthlyCostFormatted;
          var label = "".concat(subscriptionLevelCode).concat(partner ? ": ".concat(partner) : '');

          try {
            if (ReactGA) {
              ReactGA.event({
                category: 'Subscription Plan',
                action: 'New Sign Up',
                label: label,
                value: Math.round(parseFloat(subscriptionLevelMonthlyCostFormatted.replace('$', ''), 10))
              });
            }
          } catch (error) {
            log.trace('Error with Google Analytics', error);
          }

          localStorage.removeItem('enjoy-promo-code'); // handle any other of our tracking pixels

          if (partner === 'classtag') {
            var h = '//aj1775.online';
            var a = '48ecce1033f320bf54b2739e10a54792-22-205';

            if (window.location.origin === 'https://www.enjoymoviesyourway.com') {
              new Image().src = "".concat(window.location.protocol === 'https:' ? window.location.protocol : 'http:').concat(h, "/action.gif?key=").concat(a, "&t=").concat(new Date().getTime());
            } // And send an Enjoy beacon pulse pixel as well


            var host = '';
            if (window.location.hostname === 'localhost') host = 'localhost:3031';else if (window.location.host.indexOf('enjoymoviesyourway.net') > -1) host = 'account-api.enjoymoviesyourway.net';else if (window.location.host.indexOf('enjoymoviesyourway.com') > -1) host = 'account-api.enjoymoviesyourway.com'; // eslint-disable-next-line max-len

            var pixelSrc = "".concat(window.location.protocol === 'https:' ? window.location.protocol : 'http:', "//").concat(host, "/web-beacon-NA%3D%3D.gif?meta=").concat(escape(label));
            log.trace('pixelSrc', pixelSrc);
            new Image().src = pixelSrc;
            localStorage.removeItem('partner-origin');
          } // clean up stray localstorage potentially used during signup


          localStorage.removeItem('tv-signup-initialized-using');
          onComplete();
        } else {
          log.trace("setUserSignupComplete errors: ".concat(errors));

          try {
            if (ReactGA) {
              var _subscriptionLevelCode = user.subscriptionLevelCode;
              ReactGA.event({
                category: 'Subscription Plan',
                action: "New Sign Up FAIL - ".concat(_subscriptionLevelCode),
                label: JSON.stringify(errors)
              });
            }
          } catch (error) {
            log.trace('Error with Google Analytics', error);
          }

          _this.setState({
            errors: ['Oops! We had trouble at the end of the signup process.', 'Please try again a little later.', "Response from server was: ".concat(errors[0].message)],
            processing: false
          });
        }
      });
    };

    _this.handleValidatedPromoCode = function (_ref) {
      var code = _ref.code,
          activationMessage = _ref.activationMessage,
          codeEntryWindowDays = _ref.codeEntryWindowDays;

      if (code) {
        setLocalStorageWithExpiry('enjoy-promo-code', code, 604800000);
        log.trace(activationMessage, codeEntryWindowDays);
      }

      _this.forceUpdate();
    };

    _this.handleInvalidPromoCode = function (_ref2) {
      var message = _ref2.message;
      log.trace(message);
    };

    _this.handleCodeRemoved = function () {
      localStorage.removeItem('enjoy-promo-code'); // setLocalStorageWithExpiry('enjoy-promo-code', DEFAULT_PROMO_CODE, 604800000);

      _this.forceUpdate();
    };

    return _this;
  }

  _createClass(Step4ConfirmDetails, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          _onComplete = _this$props.onComplete,
          onChangePlanClick = _this$props.onChangePlanClick,
          onTermsClick = _this$props.onTermsClick,
          onPrivacyClick = _this$props.onPrivacyClick,
          onEditPaymentClick = _this$props.onEditPaymentClick,
          onChangeEmailClick = _this$props.onChangeEmailClick,
          user = _this$props.user,
          planSelectDisabled = _this$props.planSelectDisabled,
          darkMode = _this$props.darkMode,
          loadUser = _this$props.loadUser,
          context = _this$props.context;
      var _this$state = this.state,
          errors = _this$state.errors,
          processing = _this$state.processing;
      var promoCode = getLocalStorageWithExpiry('enjoy-promo-code'); // let monthlyCostMessage;
      // if (promoCode === DEFAULT_PROMO_CODE && user?.subscriptionLevelCode !== FREE) {
      //     promoCode = null; // this will make it so this special promo code isn't shown in the promo code box
      //     monthlyCostMessage = <i style={{ fontSize: '0.9em' }}>&nbsp;&nbsp;&nbsp;[first 7 days free]</i>;
      // }

      var monthlyCostMessage = /*#__PURE__*/React.createElement("i", {
        style: {
          fontSize: '0.9em'
        }
      }, /*#__PURE__*/React.createElement("br", null), "[first 7 days free]");
      log.trace('promoCode', promoCode, DEFAULT_PROMO_CODE);
      return /*#__PURE__*/React.createElement("div", {
        className: "wizardStepBase confirmDetails"
      }, /*#__PURE__*/React.createElement(Header, {
        color: "grey",
        as: "h2",
        textAlign: "center"
      }, /*#__PURE__*/React.createElement("div", {
        className: "stepTitle"
      }, user.verifiedOn && /*#__PURE__*/React.createElement(React.Fragment, null, "Nice. Your account has been verified!", /*#__PURE__*/React.createElement("br", null)), "Confirm your details.")), /*#__PURE__*/React.createElement(Divider, {
        hidden: true
      }), /*#__PURE__*/React.createElement("div", {
        className: "subscribeStepContent"
      }, /*#__PURE__*/React.createElement(ConfirmDetailsForm, {
        onTermsClick: onTermsClick,
        onPrivacyClick: onPrivacyClick,
        onEditPaymentClick: onEditPaymentClick,
        onChangePlanClick: onChangePlanClick,
        onComplete: function onComplete() {
          return _this2.handleComplete(user, _onComplete);
        },
        processing: processing,
        user: user,
        onValidatedPromoCode: this.handleValidatedPromoCode,
        onInvalidPromoCode: this.handleInvalidPromoCode,
        onCodeRemoved: this.handleCodeRemoved,
        defaultPromoCode: promoCode,
        onChangeEmail: onChangeEmailClick,
        monthlyCostMessage: monthlyCostMessage,
        planSelectDisabled: planSelectDisabled,
        darkMode: darkMode,
        loadUser: loadUser,
        context: context
      }), /*#__PURE__*/React.createElement(Divider, {
        hidden: true
      }), errors.length > 0 && /*#__PURE__*/React.createElement(Message, {
        size: "small",
        error: true,
        header: "Trouble completing the sign up process...",
        list: errors
      })));
    }
  }]);

  return Step4ConfirmDetails;
}(React.Component);

Step4ConfirmDetails.defaultProps = {
  onChangeEmailClick: null,
  planSelectDisabled: false,
  context: {},
  darkMode: false
};
export default Step4ConfirmDetails;